export default "__VITE_ASSET__DshVOJiR__"